/* eslint-disable */
import Auth from '@/resources/Auth.js'
import toast from '@/lib/cinnamon-toast/CinnamonToast.js'
import moment from 'moment'

export default {
  login ($credentials) {
    return new Promise((resolve, reject) => {
      Auth.authenticate($credentials)
        .then((response) => {
          if (response.error) {
            resolve({ success: false })
          } else {
            this.setJWT(response.token)
            resolve({ success: true })
          }
        })
    })
  },
  logout () {
    this.unsetJWT()
    if (window.location.pathname !== '/login') {
      window.location = '/'
    }
  },
  setJWT (token) {
    localStorage.setItem('TRAX_JWT', token)
  },
  unsetJWT () {
    localStorage.removeItem('TRAX_JWT')
  },
  getJWT () {
    return localStorage.getItem('TRAX_JWT')
  },
  getClaims () {
    let token = this.getJWT()
    if (!token) return null
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace('-', '+').replace('_', '/')
    let claims = JSON.parse(window.atob(base64))
    if (claims.exp < moment().unix()) {
      this.unsetJWT()
      return null
    }
    return claims
  },
  refreshTokenIfNearExpiration () {
    let now = moment.utc().unix()
    let claims = this.getClaims()
    if (claims) {
      let diff = (claims.exp - now) / 60
      if (diff < 30) {
        Auth.refreshToken()
          .then((response) => {
            if (!response.error) {
              this.setJWT(response.token)
            }
          })
      }
    }
  }
}
